import $ from "jquery";
function createHandlers($tbody) {
    $tbody.find("> tr:not(.no-items) > :first-child").each(function() {
        if (!$(this).children(".rcpo-handler").length) {
            $(this).append('<div class="rcpo-handler"><span class="spinner"></spin></div>');
        }
    });
}
export { createHandlers };
